module.exports = __webpack_public_path__ + "files/a384b8f1f15f3eef77d9f98848ba4a34.svg";